module.exports = __webpack_public_path__ + "img/FULL-GAFAM-pop-in-espace-client-VF-02.83cbf5e4.png";